import { render, staticRenderFns } from "./middle2right.vue?vue&type=template&id=79bc2fef&scoped=true&"
import script from "./middle2right.vue?vue&type=script&lang=js&"
export * from "./middle2right.vue?vue&type=script&lang=js&"
import style0 from "./middle2right.vue?vue&type=style&index=0&id=79bc2fef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bc2fef",
  null
  
)

export default component.exports